import Vue from 'vue'
import VueRouter from 'vue-router'
// 个人中心
const Setting = resolve => require.ensure([], () => resolve(require('../views/Setting/Setting')), "setting")
const ModifyInfo = resolve => require.ensure([], () => resolve(require('../views/Setting/Widgets/ModifyInfo')), "setting")
const ModifyPwd = resolve => require.ensure([], () => resolve(require('../views/Setting/Widgets/ModifyPwd')), "setting")
const ClassManagement = resolve => require.ensure([], () => resolve(require('../views/Setting/Widgets/ClassManagement')), "setting")
const DeviceManagement = resolve => require.ensure([], () => resolve(require('../views/Setting/Widgets/DeviceManagement')), "setting")
const TeachQualification = resolve => require.ensure([], () => resolve(require('../views/Setting/Widgets/TeachQualification')), "setting")
// 关联账号
const RelationAccount = resolve => require.ensure([], () => resolve(require('../views/Setting/Widgets/RelationAccount')), 'setting')
// 统一登录
const SignIn = resolve => require.ensure([], () => resolve(require('../views/SignIn/SignIn')), "signin")
const LenovoModuleSelect = resolve => require.ensure([], () => resolve(require('../views/SignIn/LenovoModuleSelect')), "lenovo.moduleselect")
const LenovoDownload = resolve => require.ensure([], () => resolve(require('../views/SignIn/LenovoDownload')), "lenovo.download")
const LenovoAbout = resolve => require.ensure([], () => resolve(require('../views/About/LenovoAbout')), "lenovo.about")
Vue.use(VueRouter)

// 账号关联
const AccountRelation = resolve => require.ensure([], () => resolve(require('../views/AccountRelation/Index')), 'relation.index')

// 第三方相关
const CloudDiskIndex = resolve => require.ensure([], () => resolve(require('../views/ThirdParty/CloudDisk/Index')), 'third.index')
const MarketClient = resolve => require.ensure([], () => resolve(require('../views/ThirdParty/CloudDisk/MarketClient')), 'third.market')

// 中转页
const GoToView = resolve => require.ensure([], () => resolve(require('../views/Home/GoToView.vue')), 'home.gotoview')

const routes = [
  {
    path: '/',
    redirect: "/SignIn"
  },
  {
    path: '/Setting',
    name: '个人中心',
    component: Setting,
    meta:{ title:'个人中心'},
    redirect: "/ModifyInfo",
    children:[{
      path:'/ModifyInfo',
      component:ModifyInfo,
      name:'修改资料',
      meta:{ title:'个人中心'},
    },{
      path:'/ModifyPwd',
      component:ModifyPwd,
      name:'修改密码',
      meta:{ title:'个人中心'},
    },{
      path:'/ClassManagement',
      component:ClassManagement,
      name:'班级管理',
      meta:{ title:'个人中心'},
    },{
      path:'/DeviceManagement',
      component:DeviceManagement,
      name:'设备管理',
      meta:{ title:'个人中心'},
    },{
      path:'/TeachQualification',
      component:TeachQualification,
      name:'任教资历',
      meta:{ title:'个人中心'},
    },{
      path:'/Relation',
      component:RelationAccount,
      name:'关联备授课账号',
      meta:{ title:'个人中心'},
    }]
  },
  {
    path: '/SignIn',
    name: 'unifiedLogin',
    component: SignIn
  },
  {
    path: '/GoToView',
    name: '中转',
    component: GoToView
  },
  {
    path: '/LenovoModuleSelect',
    name: '联想选择页',
    component: LenovoModuleSelect,
    meta:{ title:'联想教学教研'},
  },
  {
    path: '/Intelligence/installer',
    name: '联想下载页',
    component: LenovoDownload,
    meta:{ title:'联想教学教研'},
  },
  {
    path:'/LenovoAbout',
    component:LenovoAbout,
    name:'联想关于页',
    meta:{ title:'联想教学教研'},
  },
  /**
   * @params
   * 账号关联
   */
  {
    path: '/Relation',
    name: '账号关联',
    component: AccountRelation,
    meta: { title: '账号关联' }
  },
  /**
   * @params
   * 第三方相关
   */
  {
    path: '/CloudDisk/SignIn',
    name: '云碟跳转',
    component: CloudDiskIndex,
    meta: { title: '云碟' }
  },
  {
    path: '/CloudDisk/Market',
    name: 'cloudDiskMarket',
    component: MarketClient,
    meta: { title: '云碟' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
